import { render, staticRenderFns } from "./DailyHealthReportAllBuV4.vue?vue&type=template&id=40d97d15&scoped=true&"
import script from "./DailyHealthReportAllBuV4.vue?vue&type=script&lang=js&"
export * from "./DailyHealthReportAllBuV4.vue?vue&type=script&lang=js&"
import style0 from "./DailyHealthReport.scss?vue&type=style&index=0&id=40d97d15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d97d15",
  null
  
)

/* custom blocks */
import block0 from "./DailyHealthReportAllBuV4.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=https%3A%2F%2Funpkg.com%2Fbootstrap-vue%40latest%2Fdist%2Fbootstrap-vue.min.css"
if (typeof block0 === 'function') block0(component)

export default component.exports